import {Routes} from "@angular/router";
import { CatalogTableComponent } from "./catalog-table/catalog-table.component";
import { OrderTableComponent } from "./order-table/order-table.component";
import { LogoutPageComponent } from "./logout-page/logout-page.component";


export const ComponentRoutes: Routes = [
    // {path: 'app/catalog', component: CatalogTableComponent},
    // {path: 'app/order', component: OrderTableComponent},
    {path: 'app/logout', component: LogoutPageComponent}
   
];
